import { render, staticRenderFns } from "./QaQuestionContentTeacherAnswer.vue?vue&type=template&id=b0196c66&scoped=true&"
import script from "@/scripts/QA/Question/components/QaQuestionContentTeacherAnswer?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/QaQuestionContentTeacherAnswer?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0196c66",
  null
  
)

export default component.exports